import { type LogoProps } from '../registry';

export function SLGolfLoungeLogo({
  width = 1024,
  height = 1024,
  className = 'h-auto max-w-full',
  ariaHidden = true,
}: LogoProps) {
  return (
    <svg
      id="slgolflounge-logo-layer"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      width={width}
      height={height}
      className={className}
      aria-hidden={ariaHidden}
    >
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M861.407349,420.803040 
	C861.542603,421.736267 861.683594,422.227234 861.700928,422.722534 
	C862.388245,442.390228 867.105835,461.720093 865.805359,481.616394 
	C865.017517,493.670502 868.469849,505.646088 868.302124,517.876160 
	C868.184753,526.427185 865.908936,534.643311 866.009094,543.172974 
	C866.122192,552.810486 865.723572,562.462769 865.275085,572.095947 
	C864.665527,585.187561 862.414551,598.157715 860.712646,611.094788 
	C859.848022,617.667480 859.885925,624.802246 857.748413,630.918335 
	C854.824829,639.283630 855.716675,648.317505 851.861694,656.403931 
	C850.578247,659.096375 851.566223,662.807312 850.513367,665.685913 
	C847.180786,674.796936 846.052917,684.542603 842.776367,693.516174 
	C840.886841,698.690918 839.998901,704.203857 837.497925,709.317749 
	C835.337585,713.735229 834.529358,719.040649 832.488708,723.726135 
	C830.352539,728.631042 828.475586,733.705261 826.684143,738.666626 
	C824.111328,745.791687 820.414673,752.378601 817.917236,759.523987 
	C815.775024,765.653076 812.335693,771.340027 809.345337,777.158386 
	C806.127502,783.419128 802.964294,789.722473 799.405762,795.789307 
	C796.168518,801.308533 792.527832,806.600830 788.895264,811.876343 
	C782.964417,820.489807 777.471436,829.383911 771.105652,837.724670 
	C756.904358,856.331726 740.566895,872.907532 723.477966,888.772705 
	C710.377014,900.935547 695.553894,910.833313 680.612671,920.582214 
	C670.642578,927.087463 660.232666,932.931030 649.359619,937.423218 
	C641.695435,940.589722 634.100098,944.206055 626.053406,946.758911 
	C621.103333,948.329224 615.799744,949.826599 610.842041,952.009399 
	C605.860657,954.202637 600.157837,955.845520 594.830811,956.607117 
	C585.992859,957.870789 577.105957,959.696472 568.610352,961.659180 
	C550.407349,965.864502 532.209595,963.815735 514.057800,964.763367 
	C501.117401,965.438904 487.921661,965.626160 475.153046,963.818787 
	C464.635590,962.330078 453.971039,960.860291 443.495178,958.197205 
	C436.882782,956.516418 430.352478,954.055603 423.463989,953.054626 
	C418.329926,952.308655 413.342194,950.284790 408.408936,948.499390 
	C402.765778,946.457031 397.393921,943.781006 391.662720,941.837952 
	C384.879272,939.538147 378.550110,935.890991 372.039612,932.795166 
	C364.308716,929.119019 356.927399,924.803894 349.693298,920.250793 
	C334.603638,910.753479 320.239441,900.332092 306.819244,888.502075 
	C291.796509,875.259399 277.720184,861.099060 264.973846,845.754517 
	C256.246002,835.247559 248.106384,824.180481 240.706436,812.583252 
	C235.131226,803.845764 229.294922,795.229614 224.551300,786.058167 
	C220.046234,777.347900 214.297546,769.242554 211.348679,759.694397 
	C210.402542,756.630920 208.324615,753.901978 206.990555,750.858154 
	C203.250717,742.325317 199.309387,733.911621 196.489609,724.982300 
	C195.417084,721.585999 193.625946,718.398621 192.464417,714.920288 
	C188.777588,703.879395 185.108643,692.852173 181.703583,681.716187 
	C179.807053,675.513733 180.117630,668.506775 176.044617,662.957275 
	C175.766785,662.578735 175.606873,662.006409 175.625656,661.533386 
	C175.945908,653.469727 173.167160,645.687439 170.925262,638.437256 
	C167.751266,628.172607 169.849945,617.168335 165.030975,607.443787 
	C164.747314,606.871277 164.698273,606.148193 164.668304,605.489319 
	C163.787445,586.127014 159.440872,567.060486 160.226196,547.513977 
	C160.527985,540.002747 159.616211,532.376709 158.607758,524.772156 
	C157.241943,514.472595 157.185593,503.867981 159.027176,493.421356 
	C160.736771,483.723450 160.366699,473.876007 160.604538,464.082764 
	C160.834366,454.620148 160.162140,445.163116 163.378754,435.894714 
	C164.575989,432.444885 163.805923,428.298859 163.860947,424.469269 
	C163.945297,418.598633 164.594818,412.829468 166.961639,407.390839 
	C167.729111,405.627289 167.736160,403.822235 167.702774,401.999023 
	C167.610733,396.972412 167.575989,391.989288 170.543915,387.542084 
	C171.070145,386.753540 171.452118,385.587494 171.317139,384.682861 
	C170.096588,376.503113 173.657700,368.937775 175.607834,361.535034 
	C177.458099,354.511475 177.985291,347.002747 181.348694,340.191650 
	C183.544266,335.745483 183.872208,330.405304 185.575577,325.530853 
	C188.933701,315.920898 192.368530,306.330688 195.616348,296.699066 
	C197.226089,291.925232 200.255981,287.742859 200.943344,282.563965 
	C201.461731,278.658478 204.184982,275.401062 205.824646,271.822754 
	C211.224411,260.038696 216.866440,248.323166 223.210007,237.027542 
	C228.259323,228.036514 234.144470,219.456146 239.596390,210.709015 
	C246.042206,200.367264 253.549896,190.849396 260.508026,180.956116 
	C266.438293,172.524246 274.262909,165.365189 281.613342,158.006485 
	C291.181244,148.427841 300.501038,138.572998 311.143280,130.109695 
	C322.143951,121.361343 333.509216,113.125870 345.531433,105.859459 
	C353.658112,100.947571 361.782593,95.851578 370.438324,92.043037 
	C380.316864,87.696449 390.091125,83.086769 400.309296,79.372063 
	C409.552246,76.011887 419.298065,74.224953 428.239502,70.044304 
	C429.422668,69.491096 430.800568,69.166008 432.107056,69.098480 
	C436.912506,68.850121 441.566254,66.875267 446.014465,66.443527 
	C456.590179,65.417046 466.688538,61.670860 477.387756,61.719067 
	C501.048676,61.825676 524.727417,61.222576 548.364624,61.978531 
	C560.158691,62.355721 571.852051,64.935944 583.411377,68.036217 
	C589.375183,69.635735 595.480652,71.121124 601.526123,72.369637 
	C607.412292,73.585243 612.692810,76.251152 618.492737,77.573639 
	C624.437622,78.929192 630.134521,81.534050 635.794189,83.935539 
	C641.999756,86.568649 647.990906,89.703156 654.163574,92.418877 
	C660.620728,95.259720 666.605774,99.033012 672.701233,102.457024 
	C682.437683,107.926338 691.879639,114.103455 700.555908,121.239883 
	C704.078796,124.137527 708.123962,126.235947 711.456421,129.461502 
	C720.102478,137.830078 730.094788,144.698563 738.385132,153.503464 
	C750.886536,166.780823 762.687805,180.637222 773.797180,195.099503 
	C784.473206,208.997726 793.392944,224.079468 802.085327,239.182068 
	C806.743347,247.275116 810.846924,255.932648 814.647766,264.630402 
	C817.383972,270.891998 821.019165,276.777649 823.143311,283.361145 
	C824.885376,288.760315 827.663635,293.739868 829.451233,299.159882 
	C830.726746,303.027008 832.062012,307.091064 833.984131,310.568604 
	C836.733032,315.541992 836.169678,321.450897 839.658081,326.204193 
	C841.316711,328.464111 841.168396,332.115356 841.958679,335.089783 
	C843.645203,341.436768 847.294128,347.285522 847.244568,354.074707 
	C847.225708,356.656189 847.696655,359.004272 849.270569,361.121216 
	C849.853516,361.905273 850.557312,362.925507 850.510315,363.800720 
	C850.102905,371.391296 854.547363,378.074707 854.455811,385.612854 
	C854.421509,388.430847 855.016113,391.225952 856.507202,393.760559 
	C857.086121,394.744598 857.654358,395.919312 857.675293,397.017670 
	C857.826660,404.977325 859.052917,412.750671 861.407349,420.803040 
M169.995422,566.955566 
	C170.051453,567.786926 170.118927,568.617676 170.161758,569.449707 
	C170.598129,577.928162 169.444565,586.889648 171.843704,594.769775 
	C175.258514,605.986023 174.436157,617.612793 177.464005,628.912964 
	C179.609024,636.918274 182.561279,645.331360 182.380325,654.043274 
	C182.367538,654.658203 182.779724,655.305542 183.071793,655.899658 
	C186.147568,662.156921 186.565948,669.211792 188.481583,675.798767 
	C190.149628,681.534363 192.264343,687.326721 193.646423,693.249512 
	C194.540573,697.081177 195.197235,701.511963 197.147263,704.865662 
	C200.345291,710.365723 200.673813,716.718018 203.615173,722.192749 
	C205.631653,725.946045 206.373520,730.425720 208.253448,734.011292 
	C211.753433,740.686707 213.828934,747.933350 217.749466,754.471436 
	C222.626022,762.603943 225.476288,771.953613 230.372299,780.071655 
	C235.804718,789.079041 240.920776,798.290833 246.911514,806.999756 
	C257.959778,823.060974 269.257263,838.814087 282.507660,853.231384 
	C300.922760,873.268311 320.798859,891.512817 343.452271,906.598999 
	C354.071564,913.670898 365.072968,920.077637 376.658203,925.612854 
	C386.276764,930.208374 396.017914,934.493225 405.869843,938.469543 
	C409.766937,940.042480 413.743164,942.143616 417.889343,942.662048 
	C424.345825,943.469360 430.488892,945.918457 436.306885,947.941467 
	C444.408417,950.758301 452.828491,950.919617 460.933533,953.259216 
	C469.293640,955.672424 478.571930,956.144409 487.320740,957.029480 
	C505.972382,958.916443 524.912537,958.057739 543.731018,957.364868 
	C544.384277,957.340820 545.057190,957.146606 545.672607,956.907410 
	C552.804260,954.135681 560.310547,954.220520 567.785278,953.743591 
	C575.170471,953.272400 582.340820,951.008423 589.496460,949.396667 
	C594.244995,948.327148 599.659790,948.146484 603.739624,945.863403 
	C608.665588,943.106689 614.077637,941.848877 619.097656,940.476685 
	C630.284119,937.418823 640.611511,932.434204 650.993042,927.780090 
	C662.184448,922.762939 672.710876,916.119019 683.127380,909.550659 
	C698.667603,899.751282 712.823181,888.003540 726.285461,875.590332 
	C741.837524,861.250244 755.555542,845.130859 767.926331,827.941345 
	C773.803223,819.775330 779.488586,811.458252 784.933777,802.999146 
	C789.100708,796.525940 793.035706,789.867676 796.566833,783.029907 
	C801.143250,774.168091 806.237793,765.561279 810.011353,756.286377 
	C812.900818,749.184326 816.009277,742.171631 818.960754,735.094360 
	C821.932800,727.967773 824.287231,720.604309 826.985229,713.391724 
	C829.453125,706.794373 831.132019,699.965332 833.684204,693.462524 
	C835.762573,688.166931 836.240356,682.561279 837.998047,677.317139 
	C840.984558,668.406860 843.316956,659.403870 844.683899,650.126160 
	C844.877075,648.815247 844.968872,647.409668 845.521606,646.244202 
	C849.484253,637.889282 849.797424,628.423401 850.973572,619.782166 
	C852.700745,607.091858 856.464355,594.434326 855.404114,581.346069 
	C854.616089,571.618713 859.193787,562.492493 858.825562,552.757019 
	C857.570740,519.583618 860.669800,486.390045 856.223206,453.147308 
	C854.222961,438.193878 850.646423,423.151733 851.524292,407.795074 
	C851.585266,406.728943 851.058105,405.439331 850.398621,404.556793 
	C848.265869,401.702393 847.674927,398.454834 847.905396,395.086700 
	C848.485535,386.609314 844.560120,378.946594 842.926819,370.953552 
	C841.534058,364.137665 841.846924,356.342621 837.310059,350.170105 
	C836.790466,349.463165 837.096252,348.199585 836.834595,347.244720 
	C835.191284,341.249725 833.631958,335.226501 831.778442,329.295837 
	C829.970764,323.511383 827.870850,317.817200 825.851685,312.100189 
	C823.234741,304.690826 821.354980,296.885712 817.733765,289.999878 
	C812.928223,280.861938 809.563782,271.102112 804.519470,262.055908 
	C801.373474,256.414093 799.314819,249.793839 795.862854,244.505264 
	C788.936157,233.893311 782.966614,222.709564 775.683716,212.276917 
	C766.605164,199.271927 757.414978,186.360779 746.903625,174.569000 
	C730.623352,156.305374 712.740784,139.748718 692.643250,125.513901 
	C679.611023,116.283325 666.121887,108.021530 651.904846,100.910675 
	C640.165405,95.039024 628.280029,89.534836 615.668152,85.533920 
	C611.614807,84.248070 607.197144,83.889046 603.435547,81.849342 
	C596.929138,78.321320 589.552795,77.178238 582.642578,75.970863 
	C573.264832,74.332367 564.027710,70.993187 554.218384,71.696373 
	C551.480164,71.892662 548.645996,70.859299 545.865967,70.336281 
	C542.117065,69.630997 538.543640,68.051262 534.610291,68.258362 
	C513.762939,69.356018 492.730042,65.711922 472.016998,71.265831 
	C466.503815,72.744095 460.096954,71.070831 454.698273,72.757820 
	C442.443085,76.587326 429.689636,78.157509 417.434509,82.215019 
	C409.051453,84.990562 400.659515,87.989799 392.389069,90.999802 
	C381.529602,94.952057 371.145752,100.406830 360.954010,105.945274 
	C349.800751,112.006218 339.006012,118.754494 328.947235,126.578323 
	C313.529053,138.570709 298.256897,150.729248 285.270996,165.451248 
	C278.492004,173.136566 271.458527,180.575714 265.100342,188.659180 
	C257.640045,198.143860 251.081726,208.227112 244.340744,218.181488 
	C238.918564,226.188400 233.861801,234.500839 229.353424,243.052277 
	C224.776169,251.734375 219.787079,260.225525 216.136002,269.403107 
	C213.291382,276.553589 209.896484,283.480408 206.881180,290.570435 
	C204.878830,295.278687 203.254532,300.145538 201.379471,304.879242 
	C199.594269,309.386169 197.733414,313.991943 196.424942,318.670288 
	C194.614243,325.144348 192.256958,331.438751 190.506180,337.906158 
	C188.921097,343.761383 186.421799,349.500061 185.594116,355.361633 
	C184.503860,363.082703 182.790680,370.803864 180.484818,377.954102 
	C177.457428,387.341736 176.545807,397.162720 175.092163,406.481049 
	C173.253296,418.268982 170.724197,430.200378 170.453201,442.399933 
	C170.074722,459.439545 165.818848,476.265991 167.144226,493.488464 
	C167.590378,499.285767 166.916824,505.163239 167.238846,510.977264 
	C168.255814,529.338257 164.640549,547.925720 169.995422,566.955566 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M196.819031,458.975037 
	C196.921692,451.823608 195.556183,444.770691 197.963867,438.622681 
	C202.048523,428.192413 198.807632,416.744537 203.500290,406.490417 
	C204.663818,403.947937 203.363129,400.344330 204.329880,397.633057 
	C207.495819,388.754150 207.440628,379.209656 210.773148,370.281891 
	C212.731110,365.036591 213.399811,359.115906 214.880630,353.525177 
	C216.899033,345.904846 219.269180,338.436737 221.705261,330.951050 
	C223.133698,326.561676 224.701523,322.224701 226.180542,317.854340 
	C228.008102,312.454102 230.489868,307.295898 232.486328,302.023376 
	C235.039459,295.280670 237.829605,288.659546 240.780121,282.108887 
	C243.723740,275.573578 247.226227,269.291748 250.246490,262.788605 
	C252.676300,257.556763 255.926117,252.803207 258.609222,247.765625 
	C262.113556,241.186249 266.370483,235.156921 270.313171,228.896530 
	C276.286804,219.411224 282.878937,210.341553 290.096527,201.802353 
	C302.486694,187.143448 315.035187,172.704803 330.099976,160.477020 
	C343.360596,149.713669 357.194183,139.990128 371.635681,130.948273 
	C379.732513,125.878838 388.386017,121.905609 396.886322,117.796951 
	C401.089569,115.765305 406.212555,114.370148 410.506378,112.384979 
	C415.313812,110.162331 420.862976,110.296936 425.166534,107.032982 
	C425.810547,106.544533 426.661621,105.997520 427.400299,106.020142 
	C431.688965,106.151512 435.325439,103.418144 439.130890,102.915329 
	C446.842010,101.896454 454.318085,99.765144 461.789764,98.116829 
	C489.032196,92.106911 516.495728,95.100189 543.826843,95.102295 
	C554.803284,95.103134 566.155457,97.049690 576.748169,101.156677 
	C577.509949,101.452042 578.356995,101.622459 579.174194,101.665611 
	C587.825623,102.122391 595.505310,106.175201 603.701782,108.148117 
	C609.023560,109.429092 613.887939,111.792526 619.010437,113.398285 
	C625.153137,115.323853 631.375061,117.976311 637.038452,121.147461 
	C642.593628,124.257996 648.348267,127.035637 653.881409,130.207077 
	C662.503235,135.148911 670.707336,140.655731 678.620422,146.546082 
	C695.244202,158.920410 711.003296,172.325500 724.709839,187.983078 
	C738.213928,203.409424 750.850281,219.512405 761.691223,236.922424 
	C767.332458,245.981918 772.056396,255.608261 777.550171,264.765259 
	C782.801575,273.518188 786.377258,283.059875 790.964478,292.122955 
	C794.628052,299.361206 796.386536,307.560272 800.015808,314.820435 
	C802.681274,320.152527 802.627869,326.230896 806.012817,331.345856 
	C808.286194,334.781158 808.690308,339.469788 809.675354,343.421661 
	C811.257019,349.767303 812.904053,356.419312 814.923889,362.406799 
	C817.183228,369.104279 816.675110,376.478210 820.394897,382.655365 
	C820.730591,383.212769 820.977234,383.874542 821.074585,384.516754 
	C822.011963,390.698700 823.470947,396.839294 824.499939,402.912781 
	C825.876038,411.034851 827.735168,419.145203 828.720642,427.277588 
	C831.772827,452.464050 834.403564,477.754395 833.138672,503.200226 
	C832.802917,509.955505 835.635254,516.220032 835.079895,522.962219 
	C833.525757,541.829346 833.570618,560.825928 831.780151,579.626953 
	C830.859741,589.292297 830.263550,599.194580 828.285522,608.702148 
	C825.527344,621.959106 824.587097,635.627686 820.760864,648.509766 
	C818.664246,655.568665 818.261658,662.973938 815.288879,670.010071 
	C813.202515,674.948547 811.862732,680.867126 810.584839,686.459717 
	C809.166687,692.666382 806.783508,698.661804 804.674377,704.698181 
	C803.214172,708.877563 801.780884,713.078674 800.279419,717.237061 
	C795.135376,731.482910 789.010681,745.231689 782.114563,758.703247 
	C776.293518,770.074585 770.457947,781.409851 763.668640,792.247681 
	C756.217773,804.141479 747.847046,815.345154 739.267334,826.440308 
	C726.347412,843.147949 711.406311,857.902893 695.395935,871.476440 
	C682.046326,882.794250 667.376160,892.546570 652.023743,900.958435 
	C645.955811,904.283081 639.453064,907.229858 633.010437,910.034668 
	C625.841187,913.155884 618.635925,916.546631 611.261230,918.941040 
	C605.400391,920.843933 599.664246,923.302612 593.440674,924.530029 
	C587.044128,925.791626 580.631714,927.436035 574.282654,929.051819 
	C570.068726,930.124207 566.023743,931.357605 561.659973,931.282837 
	C556.804810,931.199707 552.003357,931.298523 547.542847,933.688354 
	C546.561523,934.214172 545.293823,934.329102 544.143921,934.398071 
	C525.177856,935.535034 506.095795,936.644653 487.313110,933.822449 
	C479.971527,932.719421 472.267578,932.804871 465.377899,930.708252 
	C457.796295,928.401123 449.910706,927.721497 442.332153,925.187134 
	C436.727203,923.312744 430.711700,921.625793 424.928101,919.917664 
	C420.000580,918.462341 415.001373,916.589966 410.145447,914.553711 
	C404.271210,912.090332 398.738647,909.023499 392.962677,906.460876 
	C384.694885,902.792786 376.923767,898.304626 369.155945,893.760254 
	C359.435669,888.073669 350.658844,881.040039 341.666962,874.327637 
	C328.893738,864.792725 318.000763,853.197571 306.834106,841.919800 
	C293.430176,828.382385 281.941803,813.188782 271.491852,797.413818 
	C264.111328,786.272522 256.827454,774.877075 251.298950,762.518005 
	C247.542526,754.120300 242.399765,746.328491 238.853546,737.856934 
	C236.978882,733.378601 235.133804,728.760559 233.406631,724.179382 
	C231.703781,719.662781 230.285706,714.914978 227.882706,710.679016 
	C225.898148,707.180786 225.019974,703.188171 223.884933,699.554077 
	C222.090454,693.808594 219.473480,688.309937 218.440689,682.154541 
	C217.550751,676.850525 215.681229,671.435486 213.870193,666.231140 
	C212.880203,663.386230 211.522339,660.703796 211.759827,657.692139 
	C212.030685,654.257202 209.282196,651.739807 209.085403,648.776489 
	C208.467484,639.470886 205.634323,630.569702 203.567291,621.671631 
	C201.021851,610.714111 202.589401,599.215149 198.214783,588.623108 
	C197.232422,586.244568 196.952087,583.357666 197.124207,580.756104 
	C198.273361,563.386536 193.927231,546.387329 193.786926,529.131042 
	C193.646179,511.821594 192.775162,494.461273 194.972214,477.232605 
	C195.726883,471.314850 197.212341,465.502106 196.819031,458.975037 
M347.668182,156.179321 
	C342.391785,160.433578 336.868347,164.418533 331.884094,168.991196 
	C315.051514,184.433670 299.627228,201.083389 286.380615,219.844131 
	C274.225098,237.059601 263.128204,254.765594 253.867310,273.714783 
	C247.802734,286.123810 242.319214,298.763580 237.276917,311.581970 
	C235.903702,315.072937 233.587555,318.262421 233.166092,322.133484 
	C232.537170,327.909973 229.794693,333.174713 227.838760,338.405365 
	C225.696152,344.135284 224.238159,350.174988 222.804352,355.879730 
	C221.026474,362.953491 216.767029,369.675842 217.880585,377.464081 
	C218.009277,378.364136 217.561905,379.489319 217.059921,380.314362 
	C212.868790,387.202667 213.982101,395.377289 211.788712,402.843842 
	C209.526657,410.544067 208.931091,419.105774 207.898560,427.224213 
	C206.501068,438.212341 204.817383,449.316895 204.237244,460.359528 
	C202.786591,487.971863 202.963486,515.653748 203.457626,543.312134 
	C203.609329,551.802856 202.613800,560.663391 204.721222,568.676758 
	C207.076813,577.633789 206.996414,586.416626 207.294022,595.350952 
	C207.360306,597.340454 207.097061,599.413025 208.249786,601.189148 
	C210.830383,605.165161 211.255157,609.627319 211.121017,614.156860 
	C210.852158,623.235657 214.270584,631.702393 215.920364,640.410461 
	C216.846970,645.301453 216.936859,650.794739 219.211792,655.248108 
	C222.611328,661.903015 222.591522,669.311523 224.927917,676.209412 
	C226.781311,681.681335 228.632507,687.430664 230.188965,693.081421 
	C231.924744,699.382996 234.782867,705.604370 236.947800,711.971863 
	C238.252457,715.809021 239.187912,720.169067 241.301773,723.365417 
	C245.550720,729.790344 247.059784,737.301392 250.911453,743.833679 
	C254.412079,749.770630 256.604492,756.486206 260.172424,762.374512 
	C265.530334,771.217041 270.647644,780.210999 276.078796,789.014648 
	C282.307159,799.110535 288.990723,808.918945 296.415619,817.977844 
	C308.754852,833.032593 321.831482,847.566345 336.874023,860.127197 
	C346.099823,867.830994 355.497131,875.251892 365.471771,882.018188 
	C373.486877,887.455139 382.113281,891.658875 390.417114,896.497864 
	C399.123260,901.571289 408.478577,905.178345 417.710754,908.917053 
	C422.010071,910.658264 426.405579,912.914917 431.051605,913.630127 
	C437.920593,914.687561 444.303955,917.384644 450.949890,919.120300 
	C459.570129,921.371460 468.494385,923.197144 477.026581,924.148743 
	C490.803650,925.685425 504.917114,926.164856 518.904602,925.846252 
	C531.885193,925.550659 544.844971,924.488220 557.845032,924.649048 
	C559.131348,924.664978 560.555786,924.381348 561.693359,923.800415 
	C569.678162,919.722900 578.774231,920.670288 587.194702,918.083252 
	C593.205078,916.236511 599.788513,914.817871 605.581238,912.748779 
	C613.141235,910.048462 620.873596,907.090881 628.335815,903.760437 
	C637.042297,899.874451 645.449890,895.356445 653.718628,890.867004 
	C665.853271,884.278564 677.165161,876.045959 687.896301,867.224915 
	C697.618958,859.232849 706.433044,850.253113 715.316650,841.343445 
	C728.263672,828.358276 739.527466,814.049072 749.642883,798.812805 
	C754.340393,791.737244 758.902771,784.558044 763.195496,777.231873 
	C767.247803,770.315918 771.457031,763.389893 774.504517,756.016602 
	C777.386230,749.044312 780.918823,742.410278 784.080811,735.603333 
	C787.329773,728.609009 790.008789,721.392700 792.541138,714.188171 
	C793.750610,710.747253 796.174011,707.858276 796.672424,704.202271 
	C797.587952,697.485901 801.110229,691.593079 802.735840,685.150940 
	C804.139526,679.588013 806.818237,674.205933 807.395020,668.720520 
	C808.268494,660.414612 810.928772,652.512573 812.884888,644.655273 
	C814.979248,636.242188 813.508911,626.938477 818.643372,619.282410 
	C817.578491,606.859436 823.408081,595.179016 822.582458,582.785095 
	C821.942993,573.185425 826.051208,564.133606 825.799988,554.582458 
	C824.944519,522.062500 827.325928,489.543182 823.247986,456.975159 
	C821.450989,442.623688 817.906982,428.277924 818.572449,413.595673 
	C818.607117,412.830566 818.212463,411.948090 817.777405,411.275696 
	C815.203125,407.297333 814.989258,402.817322 814.828491,398.298187 
	C814.746338,395.990112 815.003967,393.646271 813.879456,391.442444 
	C810.387024,384.597473 810.089966,376.785767 808.397644,369.531799 
	C806.808228,362.718964 804.546021,355.964905 802.821106,349.232788 
	C800.450256,339.979492 796.939392,330.816711 793.872314,321.660645 
	C790.252563,310.854431 785.649414,300.484711 780.980042,290.221497 
	C775.901062,279.057739 770.389526,268.019653 764.393555,257.240601 
	C758.366638,246.405975 751.706787,235.986877 744.706116,225.835190 
	C730.972656,205.920364 715.119507,187.691010 697.075012,171.562958 
	C687.772522,163.248413 678.003845,155.364471 667.454346,148.583801 
	C660.028809,143.811050 652.902527,138.361130 644.976440,134.627838 
	C632.997437,128.985550 621.246277,122.848900 608.744995,118.199081 
	C598.711243,114.467056 588.459473,111.337936 578.183167,109.049477 
	C568.298645,106.848259 557.968811,105.703438 547.887207,104.153152 
	C531.628906,101.653061 515.462158,101.168152 499.159149,101.255463 
	C496.152466,101.271568 493.146271,101.304939 490.247833,102.217934 
	C478.004456,106.074562 465.024567,104.974251 452.555481,107.981117 
	C446.029816,109.554749 439.327759,111.246140 433.110321,113.298386 
	C424.143677,116.258080 414.971313,118.900848 406.174713,122.685059 
	C397.291321,126.506615 388.396210,130.396500 380.095856,135.159363 
	C369.154663,141.437576 358.195709,147.882797 347.668182,156.179321 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M669.740967,276.289612 
	C677.005249,286.158905 683.593750,296.119690 688.754578,306.774353 
	C693.191956,315.935394 697.944946,324.966400 701.710205,334.533173 
	C704.769287,342.305695 707.357300,350.274689 710.500244,358.025330 
	C712.823364,363.754395 713.094666,370.339935 715.571777,375.976196 
	C718.996277,383.767731 717.795227,392.564667 721.727966,400.106171 
	C722.029297,400.683929 722.274597,401.378387 722.268433,402.015869 
	C722.173950,411.689392 726.532959,420.701477 726.390564,430.403839 
	C726.314758,435.564270 726.824097,440.694092 728.811462,445.600342 
	C730.275635,449.214935 730.147461,453.122131 730.184265,456.952454 
	C730.270691,465.949463 729.355286,475.074951 730.556885,483.915863 
	C732.603149,498.972382 733.459229,514.017273 733.315796,529.161865 
	C733.247986,536.320129 732.965210,543.415344 731.049377,550.440613 
	C729.280273,556.927979 729.863098,563.766724 730.401733,570.340393 
	C731.278625,581.041138 727.178894,591.003235 726.798645,601.407288 
	C726.439941,611.225159 723.538635,620.569275 722.029358,630.144165 
	C720.433960,640.264954 717.946594,650.445435 714.903442,660.296753 
	C710.653931,674.052979 706.038940,687.777832 700.344177,700.982971 
	C694.715820,714.034241 687.887634,726.514526 680.247559,738.678772 
	C670.330811,754.467834 659.193420,769.074463 645.603027,781.584717 
	C634.950134,791.391052 623.239075,800.063232 610.455139,807.195618 
	C603.982849,810.806763 597.308044,814.091492 590.547119,816.846802 
	C585.646729,818.843811 580.315063,820.499573 575.313660,822.333435 
	C568.097046,824.979370 560.145935,824.036560 553.335938,827.843872 
	C552.080017,828.546082 550.436707,828.904297 548.988953,828.860901 
	C533.685791,828.402649 518.537415,833.068298 503.305511,830.932495 
	C494.878143,829.750854 486.261505,830.441040 478.120392,828.694153 
	C463.204926,825.493469 448.351593,821.941956 434.242126,815.491882 
	C422.667389,810.200562 411.873199,803.865417 401.556366,796.595215 
	C388.649170,787.499451 377.378113,776.694153 367.238800,764.522339 
	C355.241852,750.120544 345.251160,734.413330 336.845856,717.841675 
	C332.002472,708.292664 328.191833,698.059082 324.106842,688.074097 
	C320.495422,679.246643 318.105865,670.063538 314.907196,661.168091 
	C312.973663,655.790894 311.875305,649.704346 310.221039,644.083008 
	C307.621094,635.248291 307.999115,625.770569 303.989014,617.312134 
	C303.573029,616.434692 303.352417,615.361328 303.384979,614.390381 
	C303.781891,602.554443 300.479584,591.129761 298.840881,579.594116 
	C293.395966,541.265564 296.793854,502.839752 295.782745,464.481445 
	C295.592957,457.282104 296.455811,450.251099 298.542084,443.292938 
	C300.129974,437.997040 298.865356,432.251862 299.834595,426.918823 
	C301.946472,415.298523 301.497192,403.209167 306.149719,392.028625 
	C306.877991,390.278473 306.745209,388.101349 306.726532,386.124329 
	C306.694366,382.719299 307.377625,379.558746 308.867432,376.478882 
	C311.460541,371.118103 311.470551,365.058411 313.429688,359.405396 
	C315.771973,352.647003 318.142273,345.818695 320.113922,338.926788 
	C321.570038,333.836823 323.299072,328.717438 325.494812,324.132111 
	C329.244171,316.302368 331.977539,307.987915 336.413055,300.496826 
	C343.791229,288.036072 351.357544,275.638397 360.385895,264.331329 
	C369.458099,252.969269 380.145233,243.133850 391.688629,234.169235 
	C403.088989,225.315659 415.533691,218.187134 428.639313,212.630966 
	C437.277740,208.968674 446.719208,206.629715 455.612671,203.517120 
	C464.574188,200.380737 474.069427,202.275482 482.747192,198.087830 
	C487.716888,195.689590 493.897186,196.728012 499.561615,196.842712 
	C512.040649,197.095352 524.709839,195.278320 536.949219,197.948120 
	C548.010986,200.361038 559.487854,201.116318 570.152466,204.927383 
	C580.885010,208.762726 591.531799,212.799408 601.875854,217.882904 
	C614.608032,224.140015 626.326477,231.606354 636.692932,240.995071 
	C648.553284,251.736893 660.371582,262.656433 669.740967,276.289612 
M306.762512,580.503540 
	C308.548279,584.511108 309.564972,588.676819 309.400787,593.095947 
	C309.009125,603.639038 314.328094,613.417969 313.568268,624.024536 
	C313.514160,624.779785 313.949768,625.666504 314.386688,626.344482 
	C316.751404,630.014038 317.168091,634.114746 317.245239,638.322754 
	C317.278351,640.129089 317.692841,641.795105 318.332977,643.574524 
	C320.554810,649.750549 323.193573,656.002380 323.924805,662.424500 
	C324.635101,668.663025 327.927673,673.744019 329.582550,679.495056 
	C330.838531,683.860046 333.233215,688.394104 334.626068,692.699158 
	C336.913696,699.769775 340.700897,706.039917 343.516144,712.759766 
	C347.094421,721.301025 352.497253,729.093323 357.274353,737.112671 
	C362.315796,745.575745 368.395966,753.343323 374.772186,760.789001 
	C384.089111,771.668457 394.235199,781.754822 406.058044,790.033264 
	C416.300201,797.204834 427.131195,803.086426 438.516815,808.378418 
	C447.724823,812.658142 457.400330,815.769775 466.870270,817.867493 
	C476.210358,819.936584 485.809174,822.513306 495.705261,822.623413 
	C517.306274,822.863647 538.863953,822.934082 560.167236,818.612061 
	C560.654358,818.513245 561.257446,818.527771 561.599731,818.241943 
	C566.839172,813.865479 573.790344,814.459656 579.803162,812.176575 
	C590.049194,808.286072 599.736511,803.486694 609.365112,798.427002 
	C617.440186,794.183594 624.285950,788.185120 631.668823,782.948792 
	C640.018066,777.026978 647.149231,769.847412 653.451965,762.188171 
	C661.147705,752.836060 668.738586,743.242676 674.830688,732.584778 
	C679.169006,724.994873 682.901917,717.120422 687.072754,709.468872 
	C690.930603,702.391541 694.175598,695.021851 696.761902,687.491272 
	C698.305298,682.997559 700.507690,678.760132 701.726868,674.153015 
	C703.318115,668.140381 704.500244,661.932617 706.889343,656.241577 
	C709.456421,650.126648 710.941772,643.428528 711.990845,637.366638 
	C713.694763,627.520813 717.030701,617.826355 716.949646,607.606445 
	C716.905334,602.028870 720.720825,597.075623 719.929565,591.107788 
	C719.298889,586.351135 720.216858,581.495056 720.641907,576.678467 
	C721.100159,571.487610 723.755798,566.895142 723.743530,561.573303 
	C723.646729,519.521606 724.945740,477.430908 719.713440,435.544586 
	C719.590332,434.559204 719.644592,433.437988 719.182800,432.626892 
	C715.974976,426.992584 716.543152,420.708618 715.902832,414.629303 
	C715.712341,412.821106 715.741089,410.880524 715.065247,409.251282 
	C711.815796,401.418304 711.598511,392.873749 709.366821,384.765625 
	C707.644287,378.507111 705.506775,372.176025 704.087097,365.733734 
	C703.275024,362.048584 703.048279,357.522827 701.050110,354.526794 
	C696.391907,347.542328 694.726868,339.418243 691.621460,331.943726 
	C687.770142,322.673767 683.349243,313.656097 678.707336,304.905151 
	C672.863342,293.888123 665.989319,283.262543 657.700684,273.732422 
	C651.080383,266.120514 645.183350,257.794342 637.260315,251.446304 
	C626.255554,242.629257 615.644348,233.204529 602.768066,227.010956 
	C596.723022,224.103226 590.880005,220.574493 584.560303,218.500778 
	C579.242676,216.755890 573.909729,214.876038 568.599121,213.129074 
	C560.898865,210.596024 552.861877,209.049805 545.129456,207.797516 
	C535.117859,206.176132 524.590759,206.607819 514.286682,206.169434 
	C504.604187,205.757477 494.943878,208.148026 485.377167,207.050156 
	C474.862640,205.843506 465.394928,210.066086 455.670563,212.034271 
	C446.804413,213.828751 437.887787,217.272186 429.331177,221.191055 
	C413.445190,228.466721 398.921448,237.559464 386.047333,249.334976 
	C377.256683,257.375488 369.421265,266.196320 362.155762,275.696381 
	C354.787048,285.331451 348.517761,295.603943 342.855133,306.174316 
	C337.446136,316.271240 333.103729,327.005920 329.120605,337.766815 
	C327.584106,341.917877 324.717804,345.708679 324.417267,350.159424 
	C323.952209,357.045776 321.112976,363.326111 319.163605,369.674896 
	C317.044159,376.577698 314.971771,383.895233 314.055603,390.598846 
	C312.762848,400.057739 310.714966,409.491455 309.270874,418.894775 
	C307.170349,432.572388 305.954346,446.152191 305.902008,459.917877 
	C305.898834,460.746399 305.701660,461.572418 305.660095,462.402893 
	C305.070343,474.184692 302.421326,485.734070 302.167389,497.589569 
	C301.770966,516.097107 303.800446,534.384949 305.627655,552.732666 
	C306.516113,561.653870 306.254822,570.689453 306.762512,580.503540 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M767.832642,431.677368 
	C767.527649,424.622131 768.348267,417.903503 764.546631,411.806122 
	C763.214600,409.669708 763.665833,407.006714 766.561951,406.109680 
	C769.418152,405.225067 772.255249,405.317444 773.642273,408.770630 
	C773.765625,409.077698 773.940674,409.418549 773.909546,409.725189 
	C772.800598,420.629425 777.268677,430.762909 778.517761,441.387024 
	C781.558228,467.247070 781.315430,493.089752 781.305786,518.976746 
	C781.302490,527.780884 782.512329,536.802307 780.091675,545.340454 
	C777.025208,556.156982 779.488525,567.297607 777.235229,578.011108 
	C775.331055,587.064087 775.709351,596.671265 773.190979,605.185303 
	C770.549438,614.115662 772.349976,623.821838 767.484802,632.108704 
	C767.028259,632.886414 767.078064,634.091064 767.200867,635.058289 
	C768.084839,642.021118 764.372498,647.893982 762.701355,654.244202 
	C762.346558,655.592468 761.339294,656.588257 759.769775,656.504883 
	C758.023315,656.412170 756.885803,655.342163 756.818848,653.679382 
	C756.631958,649.039490 755.588135,644.102722 757.649658,639.871399 
	C759.507080,636.059082 759.955383,632.325012 759.909790,628.320068 
	C759.904114,627.820923 759.772583,627.235596 759.979248,626.834229 
	C765.529114,616.054993 761.692688,603.330322 767.094849,592.525085 
	C767.312683,592.089355 767.508911,591.547363 767.455139,591.085144 
	C765.874512,577.495544 771.096985,564.541138 771.005432,551.023315 
	C770.843018,527.049377 772.611389,503.086609 771.727966,479.093231 
	C771.299072,467.447815 770.944458,455.794708 770.881714,444.143311 
	C770.858215,439.783112 767.756714,436.402802 767.832642,431.677368 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M244.797668,557.856995 
	C244.506805,534.072754 243.784485,510.763214 244.111908,487.468445 
	C244.308289,473.496063 243.096054,459.296387 245.237137,445.600067 
	C247.160233,433.298065 246.577698,420.433014 251.685623,408.632538 
	C252.514969,406.716522 253.321472,405.266815 255.462692,405.436432 
	C257.766815,405.618927 258.362885,407.407776 258.339569,409.407318 
	C258.266052,415.717224 258.299469,421.938965 256.018494,428.099152 
	C253.804565,434.078247 255.721558,440.675568 254.460510,446.912231 
	C249.700745,470.452362 251.877289,494.308350 251.107285,518.039185 
	C250.666626,531.619934 252.649719,544.841309 254.589722,558.136902 
	C254.661850,558.631409 254.832123,559.135742 254.786758,559.619568 
	C253.468369,573.680847 257.070648,587.416199 259.029114,601.049255 
	C260.421967,610.745117 260.577362,621.095703 264.632294,630.501038 
	C265.716095,633.014954 265.840729,636.020874 266.019196,638.825439 
	C266.210846,641.837708 266.313873,644.699890 268.114716,647.383728 
	C269.713104,649.765930 269.536865,652.479675 267.841187,654.898071 
	C266.967255,656.144470 265.641205,656.276306 264.249237,655.910645 
	C261.319702,655.141113 259.323547,653.049683 259.395905,650.244080 
	C259.612274,641.854919 256.422211,634.023193 255.042542,625.980103 
	C253.573334,617.414734 253.137436,608.557922 250.943588,600.330322 
	C248.974747,592.946533 247.623276,585.723694 248.074036,578.364258 
	C248.507843,571.281860 244.229843,565.256348 244.797668,557.856995 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M559.272278,852.811157 
	C561.478882,852.459412 563.282471,852.022400 565.101135,851.946777 
	C569.793579,851.751465 571.149170,853.745178 569.640137,858.194214 
	C569.108826,859.760681 568.382874,861.493896 568.587280,863.039734 
	C570.050781,874.106384 567.946289,885.363342 570.394592,896.344910 
	C570.893860,898.584412 570.810730,900.316223 568.693604,901.463074 
	C566.463928,902.670959 564.863464,901.787781 562.932251,900.239563 
	C552.850525,892.157349 543.723999,883.005005 533.786377,874.017700 
	C532.755676,876.249939 532.765747,878.344849 533.428223,879.686768 
	C536.114258,885.127808 536.281494,890.883179 536.349548,896.710693 
	C536.377686,899.116943 538.296021,899.474426 540.036682,900.110901 
	C541.282898,900.566589 542.608215,901.227966 542.335266,902.918518 
	C542.117004,904.269714 540.899536,904.711243 539.771423,904.982544 
	C537.993591,905.409973 536.189575,905.788147 534.374695,905.990906 
	C526.997070,906.815002 526.154846,905.309509 526.431702,898.161987 
	C526.791382,888.878296 526.021973,879.547852 525.643555,870.241394 
	C525.574280,868.536316 524.636230,866.978760 523.309631,865.947998 
	C520.627075,863.863892 518.277283,861.725769 520.709961,858.107971 
	C522.394226,855.603210 528.725098,855.209717 531.771240,857.196167 
	C535.699158,859.757751 538.750427,863.303223 541.985107,866.586365 
	C548.152588,872.846313 554.822449,878.465942 562.402649,883.526917 
	C560.509827,879.064941 559.536438,874.432922 559.082397,869.660767 
	C558.740234,866.064880 559.301514,862.563599 555.562378,859.433777 
	C552.736877,857.068604 555.725708,854.139648 559.272278,852.811157 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M441.868652,859.892517 
	C442.715820,870.802307 436.843536,877.641235 428.784546,882.548706 
	C416.955566,889.751831 401.579529,884.691528 394.338989,872.936401 
	C386.567627,860.319580 394.036102,845.989929 403.539612,838.485962 
	C413.391693,830.706909 428.042938,833.223145 436.936462,843.274109 
	C441.240936,848.138611 441.629211,853.638062 441.868652,859.892517 
M430.919037,857.517517 
	C430.888672,851.010315 427.373199,844.932068 422.826080,843.524780 
	C416.671021,841.619873 411.445007,843.723938 407.070282,849.689087 
	C403.608917,854.408813 403.136414,859.872620 403.444061,865.331055 
	C403.711395,870.073975 405.216095,875.031799 410.262695,876.503723 
	C415.568726,878.051392 421.439941,878.139893 425.535614,873.401184 
	C429.145447,869.224487 431.379761,864.225891 430.919037,857.517517 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M695.688721,259.919403 
	C697.936707,251.242615 702.324280,244.634521 709.544861,239.752380 
	C715.443848,235.763840 728.277649,236.036743 734.427856,239.840942 
	C739.593140,243.035904 742.741882,247.267105 745.773376,252.386627 
	C750.808777,260.890411 747.188782,268.181458 743.147156,274.766144 
	C737.639404,283.739502 728.929810,288.093170 717.960388,287.483307 
	C709.847717,287.032318 699.558655,279.006104 697.727905,271.153107 
	C696.889832,267.558136 693.726196,264.432251 695.688721,259.919403 
M708.122253,272.364258 
	C710.150696,276.273743 713.216980,277.761383 717.747253,277.868927 
	C722.443481,277.980347 726.165833,276.359650 729.605835,273.705566 
	C735.809937,268.918884 740.100403,263.218750 738.012146,254.658997 
	C737.120605,251.004608 735.248352,248.041611 731.581604,247.357513 
	C724.895020,246.110046 718.492249,246.777802 712.901489,251.473160 
	C706.383911,256.946991 703.970642,265.926605 708.122253,272.364258 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M553.022644,154.038437 
	C557.262390,159.287445 560.002991,165.328644 565.671021,168.919846 
	C566.688293,169.564331 567.353943,170.593124 566.815063,171.912643 
	C566.254822,173.284317 565.045959,173.805923 563.707336,174.139755 
	C557.101562,175.787094 552.474121,173.853424 548.752563,167.638428 
	C546.214844,163.400345 543.201843,159.571960 539.389893,155.311310 
	C538.487061,159.073715 535.900818,161.741653 539.168152,165.257706 
	C541.689331,167.970856 540.350464,170.917831 536.661194,171.001633 
	C533.021973,171.084305 529.315430,170.758865 525.736511,170.088547 
	C523.105347,169.595734 522.017761,167.745911 524.235962,165.396194 
	C528.225159,161.170456 530.021729,156.019669 529.676636,150.417526 
	C529.147644,141.828522 532.353088,133.254425 529.371399,124.626907 
	C528.402649,121.823799 531.394348,121.316177 533.237732,121.588783 
	C537.142334,122.166222 541.110840,122.918373 544.771851,124.328911 
	C547.343140,125.319550 547.089111,127.476295 545.095215,129.511658 
	C541.879272,132.794434 540.189026,136.760391 540.324951,142.222488 
	C544.046936,139.386154 547.276978,137.138428 550.241577,134.582794 
	C551.934753,133.123230 553.734802,131.412735 552.798645,128.640350 
	C552.471436,127.671196 552.600342,126.696114 553.263611,125.809532 
	C555.713684,122.534729 569.467346,124.116058 571.034607,127.919205 
	C572.111389,130.532181 571.438660,132.818619 568.517273,133.300644 
	C559.825012,134.734848 554.383850,141.284180 547.463013,145.755966 
	C548.525574,149.198532 550.861084,151.356522 553.022644,154.038437 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M614.239502,833.400452 
	C618.853149,833.602539 623.608887,837.962891 623.987549,841.917664 
	C624.157593,843.692932 623.743164,845.226501 622.174072,846.272156 
	C620.628723,847.302002 619.446350,846.495300 618.099426,845.655945 
	C610.853210,841.139954 601.964905,844.542419 597.784180,851.819214 
	C593.351135,859.535095 597.766235,865.207153 600.868774,870.922119 
	C604.652222,877.891174 611.591980,878.502136 618.808411,877.159973 
	C621.850830,876.594116 624.361511,875.353821 624.641663,872.027954 
	C624.935242,868.543274 622.512451,866.559265 619.600525,865.457642 
	C617.776917,864.767822 615.247925,865.025269 615.156067,862.388550 
	C615.069641,859.909180 617.535461,859.497437 619.267761,858.613770 
	C621.027588,857.716003 622.335632,856.156616 624.411621,855.655762 
	C629.688843,854.382874 631.606506,855.644165 631.471252,861.028137 
	C631.414368,863.291321 632.577148,864.696594 633.691528,866.364014 
	C637.079163,871.432556 635.298157,876.971436 630.166443,880.226196 
	C623.823608,884.248901 617.752441,888.046570 609.646484,887.427551 
	C601.632141,886.815552 591.460205,880.482483 588.789062,872.922852 
	C587.172119,868.346863 583.629517,864.237244 585.114624,858.783203 
	C587.839172,848.777466 592.528076,840.539612 603.043030,836.790955 
	C606.610291,835.519165 609.828125,833.257202 614.239502,833.400452 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M647.658936,839.250977 
	C644.088867,834.872681 642.098877,829.421875 635.627319,828.596313 
	C632.793579,828.234863 631.787964,825.880981 634.034973,823.430664 
	C640.557434,816.317993 649.231201,811.832581 656.341125,805.396667 
	C658.095337,803.808655 661.125305,804.290405 662.648315,806.383850 
	C664.530334,808.971008 667.485779,811.447693 666.550476,815.115906 
	C665.997192,817.285950 664.229004,816.662842 662.518738,815.722046 
	C659.322510,813.963745 653.850952,816.059753 650.737488,819.990173 
	C648.022400,823.417908 651.032532,825.293457 652.696045,827.673523 
	C654.646484,830.464172 656.551758,830.234375 658.911072,828.304626 
	C661.551758,826.144836 664.874084,824.699585 665.632812,820.779785 
	C665.860413,819.603943 667.144226,819.016724 668.388550,818.972595 
	C670.372192,818.902161 674.937073,824.830200 675.032532,827.554260 
	C675.153137,830.996216 673.241028,832.420776 670.047791,832.255615 
	C666.665833,832.080627 664.641602,834.459167 662.170593,836.068298 
	C660.469849,837.175720 660.531128,838.697815 661.449646,839.935059 
	C663.219055,842.318604 665.317200,844.457825 667.272644,846.703857 
	C668.002747,847.542419 668.889099,847.768921 669.960938,847.523499 
	C674.074707,846.581177 679.431885,840.163635 679.756897,835.690002 
	C679.918274,833.469910 680.043335,831.080627 682.678406,830.521240 
	C685.007568,830.026672 685.538269,832.248535 686.457458,833.798767 
	C690.982666,841.430237 690.842529,842.065796 683.674377,847.336304 
	C677.152832,852.131348 670.664734,856.972046 664.185974,861.824951 
	C661.038574,864.182495 658.821167,863.051086 658.742310,859.578247 
	C658.545471,850.900696 651.480164,846.210754 647.658936,839.250977 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M664.814331,218.248611 
	C666.296997,221.255676 667.382568,224.110764 669.109680,226.502548 
	C670.620239,228.594498 672.708496,230.862198 675.791443,229.613678 
	C678.536865,228.501831 680.359131,226.298599 680.708496,223.210419 
	C680.857117,221.897079 680.598511,220.530869 680.801880,219.232040 
	C681.145691,217.036026 682.291931,215.643524 684.529846,217.287277 
	C688.518005,220.216614 692.391663,223.301788 695.292358,227.416214 
	C697.184265,230.099808 695.977722,231.832367 693.297424,231.838470 
	C689.061523,231.848145 686.667480,234.300430 684.188477,237.071732 
	C680.070129,241.675568 676.144714,242.122726 671.121582,238.583344 
	C663.999268,233.564850 658.186218,227.390182 655.270996,219.018768 
	C654.171143,215.860535 654.025452,212.214935 655.301575,209.195862 
	C658.048889,202.696152 660.500061,195.670456 667.312744,192.121979 
	C673.513367,188.892334 679.397034,186.119476 687.348694,188.628342 
	C695.352539,191.153687 700.856445,195.760117 705.844177,201.801529 
	C710.455383,207.386826 708.544250,213.082779 703.184692,217.231857 
	C700.703430,219.152695 698.125366,217.234024 697.986267,213.161102 
	C697.854004,209.291794 697.556946,205.857666 694.836731,202.542801 
	C687.856628,194.036972 677.345825,194.190292 671.227051,203.331619 
	C668.229553,207.809921 664.512817,211.983353 664.814331,218.248611 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M624.393799,145.584534 
	C627.398621,148.936066 625.331482,155.973663 621.428589,156.812119 
	C619.552185,157.215225 618.231812,156.003952 618.136292,154.557251 
	C617.835083,149.993683 614.832642,148.887695 611.135010,148.385300 
	C609.425232,148.152985 608.304688,146.794617 607.124756,145.944214 
	C605.437866,146.786224 605.541748,148.328644 604.905457,149.440033 
	C601.040039,156.191650 602.748047,159.596222 610.457520,160.552185 
	C619.827026,161.714005 619.827026,161.714005 616.693542,170.324753 
	C615.222229,174.367935 612.953369,175.158722 610.221191,171.873520 
	C607.310242,168.373245 603.726929,166.428253 599.355896,164.848984 
	C598.233887,166.517380 596.911865,168.175522 595.924561,170.013504 
	C593.650635,174.246826 595.150635,177.683151 599.597900,178.947861 
	C600.698792,179.260941 601.841064,179.672546 602.763489,180.323456 
	C605.584839,182.314468 608.163086,182.536377 610.831909,179.996323 
	C612.315063,178.584671 614.163147,178.368607 615.750122,179.920212 
	C617.343384,181.477982 617.014221,183.179047 615.778687,184.850464 
	C614.599060,186.446320 613.411560,188.042816 612.344666,189.713821 
	C611.178101,191.541061 609.574707,192.143311 607.637512,191.391830 
	C600.575928,188.652527 593.550415,185.820206 586.509033,183.028702 
	C585.134216,182.483688 583.787231,181.807388 582.361938,181.461792 
	C577.470581,180.275742 576.082703,177.312744 579.943909,174.422226 
	C587.116699,169.052689 588.075073,160.633545 591.427979,153.499115 
	C593.577148,148.926193 596.722290,144.348602 595.987122,138.545197 
	C595.656128,135.932465 598.312256,134.805328 600.642944,135.806992 
	C607.292542,138.664764 613.944214,141.409393 621.076660,142.893295 
	C622.213257,143.129761 623.116943,144.485886 624.393799,145.584534 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M505.650085,864.463257 
	C504.272339,865.602173 503.452271,866.640991 503.421265,868.083191 
	C503.268097,875.210754 502.054718,882.084534 500.502167,889.105042 
	C497.721771,901.677795 486.371918,908.446472 474.534332,903.022705 
	C472.328430,902.011963 469.963104,901.932190 467.768616,900.259399 
	C457.936646,892.765076 460.609650,882.550293 461.254822,872.795410 
	C461.438446,870.019104 462.597870,867.314209 463.233398,864.558899 
	C463.835754,861.947632 464.259521,859.551758 461.881927,857.223267 
	C459.136658,854.534668 460.966461,852.558411 463.903778,852.017151 
	C466.480011,851.542358 469.212769,851.764526 471.866150,851.892029 
	C477.712067,852.172668 477.549652,853.195312 475.335724,858.524353 
	C473.026672,864.082520 472.377197,870.352722 471.210388,876.352173 
	C470.706390,878.943481 470.615814,881.632996 470.529144,884.284180 
	C470.332245,890.308960 474.754913,895.251038 480.538025,895.612793 
	C487.369232,896.040161 492.305359,892.089905 492.836212,885.498779 
	C493.316711,879.532166 493.557007,873.545105 493.839905,867.564087 
	C493.957611,865.075378 494.117615,862.548889 492.226990,860.473572 
	C491.530151,859.708679 491.238342,858.802307 491.769958,857.731995 
	C492.979431,855.297119 500.232666,854.350464 504.432556,856.378784 
	C508.199768,858.197998 508.099976,861.068542 505.650085,864.463257 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M253.202545,349.201019 
	C239.316711,345.163208 237.227814,333.145142 243.388474,320.821991 
	C244.927567,317.743378 246.403381,314.339386 250.805511,314.376892 
	C254.481232,314.408234 257.510834,315.472351 258.288849,319.489899 
	C259.054565,323.443878 255.784348,323.429382 253.295212,324.212280 
	C249.896591,325.281342 248.462662,328.165985 247.769638,331.271271 
	C247.319672,333.287384 248.921722,334.761322 250.673782,335.467621 
	C253.918900,336.775848 256.518036,335.430054 258.602234,332.912109 
	C261.362000,329.578094 264.406586,326.543976 267.851562,323.923737 
	C274.350067,318.980957 285.405457,322.964996 287.838989,330.760132 
	C290.577332,339.531555 288.977325,347.320251 283.697754,354.557556 
	C281.435699,357.658417 271.281189,358.411743 268.581299,355.707794 
	C266.763916,353.887665 267.491821,352.316589 269.454651,351.332977 
	C270.922028,350.597626 272.646698,350.394714 274.175385,349.758972 
	C277.958344,348.185760 281.541046,346.419678 280.934479,341.270294 
	C280.652802,338.878784 281.481354,336.045990 278.120850,335.099396 
	C274.908569,334.194580 272.114594,334.900604 270.136444,337.643677 
	C267.182159,341.740387 263.792725,345.265503 259.278687,347.709320 
	C257.444427,348.702362 255.677170,349.368195 253.202545,349.201019 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M284.790466,300.210571 
	C278.923920,293.033417 273.071228,286.287903 267.573486,279.264526 
	C264.545105,275.395752 267.260529,270.343658 272.220367,270.037476 
	C273.214325,269.976135 274.298004,269.805054 275.202942,270.102478 
	C285.700653,273.552979 296.792755,273.262146 307.501160,275.333435 
	C310.188232,275.853180 312.729706,276.063080 315.326233,275.004730 
	C316.812744,274.398834 318.297760,274.466461 319.274902,276.045410 
	C320.121857,277.414001 319.484436,278.530243 318.709229,279.705566 
	C316.708954,282.738098 315.461456,286.206360 312.928284,288.958801 
	C310.966492,291.090393 309.274261,291.885101 307.279724,289.253510 
	C305.055420,286.318756 301.641541,283.841431 298.575256,285.032623 
	C294.552826,286.595184 292.539215,291.137573 291.527496,295.315796 
	C290.639954,298.981140 295.840576,303.166107 300.090790,302.657318 
	C301.706665,302.463867 303.365723,301.547028 304.455505,303.613068 
	C305.432770,305.465820 305.091736,307.051697 303.776886,308.658234 
	C301.816650,311.053314 301.263733,314.465637 298.113831,316.046112 
	C295.725616,317.244324 293.575012,317.262817 293.048157,314.430115 
	C291.991028,308.746429 287.726959,305.105621 284.790466,300.210571 
M288.291870,284.688934 
	C286.130554,282.635620 283.367218,282.663879 280.129730,281.984558 
	C281.349609,285.107544 283.024567,287.132507 285.446075,287.963043 
	C286.859131,288.447754 288.164825,287.070953 288.291870,284.688934 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M776.991577,367.824738 
	C778.459473,369.926727 782.289490,370.928375 779.602661,374.027374 
	C777.090698,376.924561 774.131470,379.670898 769.750061,378.547424 
	C767.680115,378.016632 767.226318,376.250458 767.412476,374.163879 
	C767.648010,371.522339 767.706360,368.851379 767.627747,366.199432 
	C767.551025,363.608917 766.304810,361.752411 763.564819,361.289795 
	C760.161804,360.715210 753.225647,364.919769 751.938965,368.277313 
	C751.028748,370.652466 748.661560,372.633972 747.343201,370.070129 
	C745.093079,365.694336 741.133423,361.775604 741.830872,356.144257 
	C742.288147,352.452515 743.808411,350.851196 747.438843,352.989563 
	C748.951599,353.880585 750.834839,354.594147 752.196045,353.870941 
	C757.388550,351.112122 763.481628,351.474884 768.663147,348.803223 
	C769.977417,348.125610 771.423035,347.325256 772.831665,347.278107 
	C777.318115,347.127808 780.687378,345.649261 783.066284,341.516144 
	C784.464783,339.086243 787.065491,339.409912 788.061401,342.057098 
	C789.622864,346.207520 792.559998,349.925842 792.326294,354.697235 
	C792.259705,356.056671 792.661072,357.263702 793.692383,358.306061 
	C797.660400,362.316711 796.203003,367.333649 795.926147,372.024048 
	C795.788696,374.352661 793.674927,375.128510 791.509033,375.244965 
	C789.514648,375.352264 787.368042,375.654480 786.139832,373.556152 
	C785.024475,371.650665 785.976196,370.062714 787.279480,368.622040 
	C788.846313,366.890015 788.969910,365.087067 787.490051,363.229645 
	C785.759216,361.057343 786.209595,358.130341 784.859131,355.421082 
	C781.336182,356.530426 776.755798,355.716003 774.648743,359.015564 
	C773.021729,361.563385 773.986877,365.188934 776.991577,367.824738 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M484.784912,123.732361 
	C489.170471,124.087669 490.192963,127.770958 491.352783,130.301498 
	C494.084106,136.261032 496.565216,142.342331 499.379944,148.285294 
	C502.138641,154.109970 504.912201,159.921432 508.836823,165.034485 
	C511.328522,168.280716 509.882294,169.625870 506.803375,170.072296 
	C504.192017,170.450928 501.480530,170.280762 498.822144,170.159683 
	C494.924805,169.982178 492.199310,169.015427 494.208252,164.030212 
	C495.252350,161.439316 493.952515,158.387054 492.550842,156.466888 
	C489.085999,151.720230 486.908997,146.467133 485.125305,141.230942 
	C483.877350,140.741882 482.767792,141.159866 482.695465,141.842148 
	C481.994202,148.454620 477.894989,154.108353 477.451111,160.787033 
	C477.331909,162.580566 477.724335,163.936691 479.015717,165.266678 
	C481.648407,167.978073 479.946686,169.681412 477.182037,170.011887 
	C473.574127,170.443100 469.850464,170.450562 466.234772,170.077133 
	C463.896393,169.835648 461.516296,167.652176 464.106567,165.726532 
	C468.208649,162.677002 469.005432,157.866119 470.102509,154.065903 
	C471.685242,148.583511 474.691711,143.451401 475.043152,137.594681 
	C475.299316,133.325119 478.259735,130.006500 479.293671,125.955818 
	C479.870209,123.697006 482.311371,123.677910 484.784912,123.732361 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M363.028992,225.907440 
	C361.534363,225.520340 360.738983,224.598526 361.049072,223.638596 
	C362.366669,219.559982 359.439819,217.122757 357.468231,214.528015 
	C352.965729,208.602631 348.158112,202.907135 343.408447,197.172958 
	C342.275757,195.805466 341.016998,194.026367 338.880066,195.063049 
	C336.933594,196.007339 335.280060,197.312210 335.123535,199.910522 
	C334.954254,202.719940 335.750366,206.556473 331.147888,206.490524 
	C327.874664,206.443619 324.224243,200.309937 324.966644,196.876617 
	C325.617767,193.865265 328.362671,192.551788 330.425293,191.375916 
	C337.879456,187.126328 343.108795,180.323730 349.870789,175.336792 
	C351.587250,174.070923 352.676086,170.632935 355.436493,172.602631 
	C358.201935,174.575882 362.180237,176.252014 360.986664,181.016815 
	C359.585449,182.472885 357.791595,181.760468 356.215668,182.021332 
	C350.423676,182.980087 348.746246,186.854721 352.190186,191.483765 
	C357.042755,198.006210 362.264374,204.199097 367.879730,210.099014 
	C369.893433,212.214722 372.176788,211.377762 374.268036,212.097610 
	C375.702240,212.591278 377.272827,212.979614 377.642242,214.682404 
	C377.996613,216.315918 376.625214,217.017517 375.493774,217.687607 
	C371.283752,220.181030 368.611847,224.917435 363.028992,225.907440 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M379.777802,812.958679 
	C373.178192,814.491760 370.071136,819.673584 366.476379,824.156555 
	C362.751617,828.801697 359.418121,833.759949 355.710266,838.419556 
	C354.292786,840.200989 354.695312,841.445190 356.057739,842.692200 
	C359.110657,845.486633 362.103302,848.409668 366.820709,847.873352 
	C368.115601,847.726135 369.488251,847.929443 370.781586,848.189392 
	C372.300171,848.494507 373.708801,849.264648 374.109222,850.870972 
	C374.593842,852.814941 372.962402,853.503113 371.607605,854.046936 
	C370.013580,854.686707 368.823547,855.726013 367.558380,856.838013 
	C365.089233,859.008118 362.020813,858.923767 359.786499,856.885376 
	C354.050415,851.651917 347.991333,846.918823 341.469910,842.705078 
	C338.287872,840.649048 337.872009,835.868225 340.771301,834.927185 
	C347.281219,832.814148 349.765320,826.822571 353.717346,822.394775 
	C357.176331,818.519409 360.703918,814.504578 363.142487,809.710083 
	C363.989014,808.045715 364.675446,806.604797 364.849304,804.713196 
	C365.130981,801.649170 367.103241,799.789734 369.941986,801.631958 
	C373.653412,804.040527 376.911469,807.162842 380.276337,810.079895 
	C381.154388,810.841125 380.830688,811.903809 379.777802,812.958679 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M413.533051,153.323212 
	C412.858276,150.591232 411.912384,148.840027 409.201691,148.020477 
	C406.086456,147.078583 405.952179,144.973953 408.410248,142.873642 
	C410.300537,141.258484 412.156647,139.607574 414.714844,138.996567 
	C421.915344,137.276764 423.341553,138.498642 423.183563,145.833115 
	C423.048004,152.126434 426.864441,157.373199 428.237671,163.291809 
	C428.643829,165.042206 429.900574,166.641708 430.093872,168.385040 
	C430.463379,171.718353 431.152588,175.548691 434.670471,175.737946 
	C438.838715,175.962158 443.565979,174.757812 445.567596,170.260101 
	C447.041046,166.949310 448.144104,163.858887 452.561646,165.268188 
	C455.060516,166.065369 456.384766,171.779465 454.786896,175.120819 
	C453.633667,177.532303 451.785828,180.333786 449.373566,180.671661 
	C444.042908,181.418304 439.620209,184.815674 434.308868,185.201050 
	C432.004303,185.368301 430.306152,186.566727 428.401062,187.584900 
	C426.329620,188.692001 423.887421,189.365128 421.843109,187.612671 
	C419.838959,185.894608 421.301178,184.088928 422.074860,182.227295 
	C423.603180,178.549927 420.836243,175.502930 419.939301,172.289230 
	C418.185394,166.005005 417.105225,159.420670 413.533051,153.323212 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M732.822998,306.867310 
	C737.216125,307.713226 739.612122,304.445526 742.757812,303.190430 
	C747.459839,301.314331 752.022583,299.090332 756.652283,297.031586 
	C758.874146,296.043488 760.454468,294.768250 760.922241,292.042175 
	C761.374146,289.409058 763.157593,288.525665 765.726379,290.163544 
	C770.310242,293.086212 770.842163,298.483154 773.171265,302.717865 
	C774.241089,304.663055 771.311707,306.248444 769.253052,305.816864 
	C761.116760,304.111237 755.091003,308.930817 748.327332,311.841553 
	C743.818848,313.781769 739.486450,316.075073 734.611938,318.010864 
	C737.369141,323.861938 739.161377,330.216064 745.968323,332.902832 
	C747.300903,333.428802 748.197449,334.420197 748.052551,335.957306 
	C747.905334,337.518433 746.705505,338.107849 745.395569,338.584808 
	C739.712402,340.654144 734.364136,338.427979 731.689514,332.418976 
	C729.030151,326.444214 726.982788,320.229858 724.025085,314.341400 
	C721.440735,309.196167 722.683655,307.678986 728.398865,307.128937 
	C729.723267,307.001465 731.057190,306.973083 732.822998,306.867310 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M323.805115,244.184097 
	C325.321442,245.528244 326.483337,246.755035 327.849243,247.680817 
	C330.356445,249.380127 333.553162,249.531952 335.022614,247.093048 
	C337.139618,243.579498 340.789612,240.465378 339.716614,235.497986 
	C339.290466,233.525269 339.345978,231.240234 341.794586,230.484467 
	C344.615448,229.613815 345.042633,232.251175 346.465271,233.795898 
	C350.830383,238.535721 349.124664,242.611115 345.381989,246.195724 
	C339.972748,251.376450 336.116516,257.780945 331.169464,263.316406 
	C328.582275,266.211334 326.549286,266.036377 325.184052,262.733856 
	C323.734467,259.227173 321.705048,256.254669 318.698456,254.138840 
	C310.503265,248.371689 304.647766,239.534531 294.692871,236.045776 
	C292.317017,235.213135 292.106506,233.109314 293.711639,231.178101 
	C295.919861,228.521225 298.209442,225.927063 300.559662,223.394638 
	C302.580170,221.217514 304.698029,222.221252 305.102173,224.426819 
	C306.824463,233.826019 315.155945,236.821091 321.338470,241.914108 
	C322.106110,242.546494 322.809509,243.256805 323.805115,244.184097 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M608.696594,341.804993 
	C611.957275,337.009674 614.892944,332.438721 618.054443,328.029663 
	C621.299316,323.504395 626.008911,324.451569 630.366821,325.491669 
	C634.535889,326.486755 634.925659,330.126831 635.294434,333.792511 
	C636.279663,343.585052 630.605469,350.966614 625.859497,358.296661 
	C616.717834,372.415649 605.902771,385.482880 597.209595,399.850281 
	C590.383545,411.131897 583.379272,422.303345 576.419312,433.499939 
	C572.502747,439.800476 568.128174,445.814850 564.146545,452.076813 
	C559.678833,459.103271 555.403442,466.252533 551.077881,473.368713 
	C546.490662,480.915436 541.660706,488.332947 537.452454,496.086731 
	C532.684326,504.872040 527.601013,513.460876 522.600952,522.106140 
	C521.425903,524.137878 521.482056,526.859558 522.656738,528.898682 
	C526.817627,536.121887 530.884521,543.447510 534.634216,550.834412 
	C538.928406,559.293945 544.607849,566.989075 547.952881,576.007568 
	C549.799805,580.987122 553.584717,585.211609 555.916199,590.055542 
	C560.179443,598.912537 566.001160,606.911804 569.599060,616.163879 
	C571.340332,620.641785 574.481384,624.628296 577.307251,628.611206 
	C578.927185,630.894470 581.248047,632.135254 584.218018,630.304993 
	C586.563293,628.859741 589.271729,628.804199 591.962524,628.752686 
	C596.714172,628.661804 601.288818,628.921387 605.722839,625.801819 
	C608.880127,623.580444 613.443970,623.497070 617.322021,622.316528 
	C628.363708,618.955200 639.728149,616.281982 651.568420,617.705078 
	C656.652771,618.316162 658.702454,622.129272 659.978699,625.856018 
	C661.719421,630.939087 661.033508,636.125000 658.567505,641.290710 
	C656.485596,645.651672 656.108459,650.769165 653.298157,654.960144 
	C651.290161,657.954529 650.080688,661.472961 647.351807,663.999451 
	C641.488831,669.427673 634.137207,671.373840 626.569580,671.832703 
	C617.605286,672.376160 608.564148,672.344604 599.591248,671.883667 
	C587.901611,671.283203 579.792297,664.868835 573.946716,654.938965 
	C564.615723,639.088684 554.438171,623.708557 545.720947,607.535461 
	C540.365906,597.600281 534.739441,587.787292 529.604553,577.710510 
	C524.502502,567.698120 518.601257,558.095581 514.283020,547.667786 
	C513.738281,546.352356 512.454773,545.342896 511.376129,544.023560 
	C506.316345,546.519104 506.101349,552.201050 503.495880,556.133789 
	C496.618622,566.514526 491.169647,577.828918 484.581665,588.416748 
	C475.554504,602.924744 467.100342,617.779114 457.574188,631.995544 
	C451.917114,640.437927 446.453247,649.015747 440.549042,657.295166 
	C435.784149,663.977112 429.468597,668.073914 421.075104,668.184021 
	C411.746094,668.306519 402.375793,668.728027 393.093689,668.053406 
	C383.073090,667.325012 373.337433,664.681946 367.495453,655.474426 
	C364.842255,651.292786 361.371490,647.157349 361.640625,641.599976 
	C361.724426,639.869629 360.927612,638.437500 360.045197,636.968628 
	C356.013641,630.257874 357.207092,620.777832 362.626495,615.457092 
	C364.052673,614.056824 365.841156,613.763977 367.698334,613.768188 
	C373.862244,613.782043 380.027710,613.770508 386.189423,613.908875 
	C391.958801,614.038452 396.700867,617.609009 402.239838,618.849670 
	C409.511566,620.478455 416.008240,624.877991 423.834564,625.096741 
	C427.631256,625.202881 430.548096,628.706970 434.630768,628.641357 
	C438.141541,628.584900 440.344391,628.269287 442.912750,624.503906 
	C448.222260,616.719849 452.509735,608.390137 457.314972,600.370056 
	C462.188538,592.235840 467.703003,584.469055 471.782318,575.826660 
	C473.869202,571.405396 477.066559,567.518433 479.630920,563.310059 
	C484.238953,555.747803 488.749420,548.126038 493.298157,540.527588 
	C495.240295,537.283386 496.974548,533.890930 499.170013,530.828735 
	C501.508453,527.567078 501.632660,524.067810 499.874573,520.986511 
	C495.404846,513.152771 491.736786,504.900940 486.914825,497.238007 
	C483.621582,492.004547 481.727783,485.893524 478.460266,480.640106 
	C474.205688,473.799774 470.634827,466.604248 466.581818,459.669891 
	C463.444763,454.302734 460.128967,449.038788 457.050598,443.638885 
	C450.705139,432.508179 444.171722,421.495483 437.209045,410.737061 
	C433.898193,405.621307 431.890472,399.829865 428.780273,394.561096 
	C424.488556,387.290833 419.675507,380.399170 415.009338,373.395813 
	C407.968811,362.828888 401.077728,352.152496 395.662170,340.657318 
	C393.833130,336.774872 394.236359,332.168274 394.228516,327.877167 
	C394.221344,323.937805 396.459045,321.498535 400.446320,320.572052 
	C404.724152,319.578064 409.046967,320.277496 411.335815,323.622528 
	C416.734741,331.512787 421.991821,339.547699 426.392731,348.087128 
	C432.002380,358.971924 437.799042,369.760834 443.355103,380.672546 
	C446.345093,386.544678 449.022766,392.576782 451.802307,398.554901 
	C456.786987,409.275696 462.790802,419.448181 468.382996,429.844513 
	C472.904358,438.250153 477.886292,446.395325 482.075470,455.012634 
	C486.883057,464.901886 492.843781,474.227234 498.214203,483.847412 
	C501.251892,489.288879 504.455170,494.683136 506.894165,500.393250 
	C508.002533,502.988129 509.819489,504.700531 511.365814,506.954956 
	C515.236572,505.467010 516.361877,501.624481 518.175232,498.725555 
	C524.680542,488.325806 530.664978,477.601471 536.916016,467.041138 
	C544.184509,454.761993 551.493347,442.506409 558.848572,430.279022 
	C563.423096,422.674347 568.608765,415.389160 572.588196,407.490997 
	C575.396057,401.918030 578.414551,396.367310 580.719238,390.579315 
	C583.080078,384.650391 587.029236,379.736267 589.915649,374.152161 
	C595.577881,363.198029 602.228882,352.754974 608.696594,341.804993 
M399.058350,652.914734 
	C394.263855,651.665894 389.461121,650.447327 384.680267,649.148254 
	C383.401123,648.800598 381.949615,648.301392 381.797211,646.746948 
	C381.608795,644.825806 383.272278,644.310913 384.666199,643.833313 
	C387.894562,642.727173 391.190948,642.815063 394.534637,643.345520 
	C396.811584,643.706787 399.161255,644.239197 402.787903,643.101562 
	C394.599487,641.464844 388.129303,639.223083 381.537018,636.076660 
	C384.911774,630.869446 389.978119,633.827087 394.883240,631.410767 
	C389.510437,631.387756 386.002045,630.162292 382.428223,628.658386 
	C377.013397,626.379822 374.716034,628.472412 375.002838,634.184692 
	C375.238037,638.868652 376.147736,643.001953 378.671143,647.238953 
	C381.245514,651.561401 383.777802,654.019470 388.999023,653.961914 
	C395.820312,653.886536 402.801239,653.966919 407.539581,660.334290 
	C407.976105,660.920837 408.934631,661.402954 409.673553,661.436768 
	C417.637177,661.801636 425.363831,660.136230 431.378235,655.040283 
	C437.376221,649.958191 440.386780,642.337585 444.468903,634.933472 
	C437.993256,639.357239 431.734558,636.567505 425.356506,635.324768 
	C422.717010,634.810486 420.106537,634.665405 417.952728,632.833191 
	C416.881470,631.921936 415.293396,631.171936 414.306061,632.138184 
	C411.182281,635.195190 407.299469,635.368225 403.236420,635.454712 
	C409.382874,634.884277 413.766541,639.753296 419.424286,640.288086 
	C420.556824,640.395081 421.664215,641.294250 421.766174,642.592957 
	C421.890900,644.181702 420.696625,645.048767 419.363098,645.363586 
	C417.603699,645.779114 415.770111,646.096191 413.971649,646.080505 
	C411.130615,646.055786 408.292297,645.719360 405.452850,645.514771 
	C412.042206,647.335693 420.035004,645.552734 423.405731,654.127075 
	C421.661957,656.647034 418.809021,657.543335 416.808319,656.105713 
	C411.524689,652.308960 405.587463,653.840820 399.058350,652.914734 
M593.243469,653.671448 
	C596.473816,648.650574 602.181946,652.126648 607.361328,649.599915 
	C604.157715,649.452087 602.066345,649.402771 599.983154,649.244995 
	C598.217102,649.111206 596.521545,648.514465 596.380920,646.494995 
	C596.255859,644.698486 597.795166,644.035522 599.298096,643.582886 
	C603.679565,642.263367 607.206665,638.670288 612.329712,639.006592 
	C608.534363,638.387146 604.874207,638.559753 601.901855,635.718140 
	C600.900269,634.760620 598.909546,635.034424 597.660583,636.028198 
	C593.826294,639.078918 589.250427,638.694214 584.808289,639.115479 
	C582.076965,639.374512 579.295654,638.235779 576.431885,639.234558 
	C576.509705,644.085693 579.331177,647.592102 581.699707,650.984009 
	C583.559021,653.646729 584.751160,656.670410 588.082703,658.801086 
	C593.828247,662.475342 600.500916,662.008362 606.331421,664.692566 
	C607.707886,665.326172 610.873901,665.582764 610.925476,663.302490 
	C611.035828,658.421814 614.309570,658.609009 617.401794,658.371765 
	C621.712158,658.041199 626.039734,657.856262 630.362488,657.797302 
	C632.820129,657.763733 634.779907,657.289062 636.473511,655.219849 
	C641.016174,649.669739 643.560120,643.410034 643.275818,636.264954 
	C643.116882,632.270264 639.858459,630.965820 636.831299,632.379211 
	C632.453857,634.422974 627.936340,635.124451 623.261047,635.751892 
	C626.615295,636.112061 629.932739,635.958862 633.226257,636.172791 
	C635.036865,636.290405 637.170898,636.927246 637.098328,639.255127 
	C637.036560,641.237122 635.022278,642.010742 633.439209,641.992126 
	C626.935242,641.915588 621.841003,646.922058 615.300293,646.547119 
	C620.693604,646.855347 626.014343,646.793884 631.332275,646.887939 
	C633.256470,646.921936 635.136719,647.615295 635.290833,649.887634 
	C635.449768,652.231689 633.567322,652.734558 631.698059,653.252319 
	C620.411194,656.378784 608.905640,657.580566 597.218811,657.596924 
	C594.716675,657.600403 593.431946,656.866882 593.243469,653.671448 
M653.552185,629.304932 
	C651.032471,623.734070 646.407410,623.566589 641.284729,624.629517 
	C645.012634,624.899475 648.474548,625.515259 650.475098,629.300354 
	C650.808533,629.931152 652.071106,632.487854 653.552185,629.304932 
M369.367279,620.755920 
	C367.548340,621.870361 366.147522,623.324158 365.113678,625.799072 
	C369.162994,625.476929 370.211731,621.340210 373.377350,620.559814 
	C372.257751,620.559814 371.138123,620.559814 369.367279,620.755920 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M629.463135,543.691711 
	C620.071960,545.341064 611.113525,545.118652 602.286560,543.180847 
	C595.628601,541.719238 590.299683,537.487732 585.840271,532.663940 
	C574.710388,520.624390 574.669128,505.760803 578.296692,491.349274 
	C581.345093,479.238861 590.213501,471.402405 602.618164,467.386230 
	C608.922607,465.345062 615.134155,464.539520 621.582031,464.006287 
	C628.364197,463.445374 633.913086,467.475708 640.234436,468.698212 
	C642.840088,469.202087 644.934937,472.721436 645.260681,476.158813 
	C645.464661,478.312042 645.667725,480.465515 645.895996,482.616211 
	C646.157349,485.077789 646.104187,487.539124 643.158081,488.238403 
	C640.524963,488.863373 638.242249,488.045929 636.805603,485.475922 
	C632.474854,477.728333 623.970093,474.036285 615.182373,475.982819 
	C608.748230,477.407959 601.943665,477.968323 597.604126,483.992828 
	C593.365234,489.877594 588.441650,506.131470 592.947449,513.136475 
	C595.151062,516.562317 595.434204,520.838623 597.894653,524.434021 
	C603.602051,532.774048 619.281006,537.738098 628.488647,533.418640 
	C628.789124,533.277710 629.194092,533.208801 629.368530,532.972290 
	C632.867065,528.227356 629.663696,523.370911 629.505554,518.573120 
	C629.433411,516.382751 628.694153,514.340515 625.756531,514.161316 
	C623.276489,514.010193 620.982849,513.128357 621.263184,510.009460 
	C621.528381,507.059143 623.406555,505.705170 626.357910,505.639038 
	C632.182556,505.508484 638.004578,505.256866 643.829407,505.138458 
	C646.386597,505.086517 648.361389,506.045898 649.108276,508.769928 
	C649.774597,511.199829 649.155273,512.896545 646.799438,514.112000 
	C643.649475,515.737305 643.702698,519.116150 643.298401,521.961975 
	C642.833313,525.236389 643.040649,528.608337 642.983765,531.938354 
	C642.845459,540.026672 640.396423,542.678101 632.390564,543.378357 
	C631.560913,543.450928 630.732910,543.542236 629.463135,543.691711 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M434.192139,473.202271 
	C434.391602,475.955139 434.450165,478.289764 434.805542,480.578339 
	C435.181274,482.997925 434.301331,484.516876 431.999756,485.060699 
	C429.917542,485.552673 428.653534,484.555176 427.714203,482.604523 
	C423.378723,473.601410 410.844482,470.954315 403.419220,477.387085 
	C399.807892,480.515717 400.402405,487.215454 404.151489,490.224915 
	C410.496948,495.318634 418.315552,497.361816 425.570801,500.187897 
	C438.721710,505.310516 441.453125,524.329895 431.844971,533.277527 
	C420.681702,543.673279 408.380066,545.837952 394.003143,540.933044 
	C388.765961,539.146362 387.105652,536.736267 387.538269,531.705017 
	C387.735260,529.414246 387.200592,527.066101 387.067017,524.739929 
	C386.925476,522.274536 387.279480,519.901062 390.062897,519.108948 
	C392.765106,518.339905 393.837708,520.487427 395.022644,522.333435 
	C397.076355,525.533020 397.605072,529.400391 401.929810,531.484863 
	C408.498352,534.650818 417.546478,534.245789 422.716614,529.126099 
	C426.353516,525.524719 424.541199,516.549500 420.086609,514.093445 
	C414.254791,510.878021 407.916626,509.072693 401.808167,506.625031 
	C393.134399,503.149506 388.048401,492.601990 390.427856,483.509308 
	C394.657532,467.346283 411.323944,459.498901 426.566345,466.577118 
	C429.577423,467.975372 434.467621,467.243896 434.192139,473.202271 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M514.227051,345.374695 
	C510.825409,346.405426 510.421967,349.022858 510.403900,351.503967 
	C510.287598,367.490295 510.306458,383.477600 510.284424,399.464600 
	C510.280792,402.107910 511.622620,403.388580 514.253906,403.558868 
	C520.610413,403.970245 526.873169,403.457672 533.084412,402.035065 
	C535.506836,401.480255 536.531189,399.823578 537.512024,397.758911 
	C538.932251,394.769287 540.639343,391.494751 544.671448,392.173859 
	C547.383545,392.630676 547.995789,397.749237 545.823181,401.935394 
	C544.726562,404.048340 543.877441,406.189636 543.553345,408.491302 
	C542.862549,413.398071 539.865356,415.244598 535.231201,415.211761 
	C521.933167,415.117462 508.634827,415.064423 495.336884,414.957886 
	C492.753204,414.937195 490.179382,414.501678 489.176117,411.687958 
	C488.237396,409.055298 490.166473,407.699310 491.754852,405.839081 
	C495.162903,401.847565 496.448914,396.658966 496.572388,391.555450 
	C496.878448,378.904022 496.674805,366.240570 496.709076,353.582031 
	C496.718567,350.074005 495.030457,347.538330 492.206360,345.762329 
	C490.031433,344.394592 489.417389,342.539001 489.940796,340.214813 
	C490.526581,337.613770 492.585846,336.910583 494.881287,336.911072 
	C500.373505,336.912292 505.872131,336.913391 511.354736,337.185791 
	C513.537048,337.294220 515.514771,338.281342 516.357117,340.704834 
	C517.085205,342.799713 516.563538,344.271973 514.227051,345.374695 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M534.209900,663.266113 
	C534.611511,662.695618 534.780457,662.383057 535.038208,662.187805 
	C537.103394,660.624329 538.148560,656.480286 541.719421,658.568054 
	C545.300598,660.661987 543.608154,664.346191 542.776855,667.183716 
	C541.955322,669.987854 540.198120,672.436462 539.887329,675.559631 
	C539.613281,678.313721 537.164795,679.187988 534.650940,679.189758 
	C519.652954,679.200195 504.654785,679.180176 489.657104,679.093628 
	C487.614502,679.081848 485.416931,678.495361 484.809082,676.286865 
	C484.247162,674.245483 486.440613,673.795105 487.654663,672.738770 
	C491.074860,669.762878 492.704956,665.654846 492.773224,661.336060 
	C492.999786,647.007324 492.806488,632.672424 492.890259,618.340576 
	C492.910889,614.810364 490.448059,613.067627 488.361206,610.965942 
	C486.801208,609.394897 485.231964,607.700745 486.169861,605.293579 
	C487.142578,602.796936 489.526062,602.889038 491.704315,602.875427 
	C497.370758,602.839844 503.037415,602.833679 508.704010,602.840515 
	C510.930115,602.843201 513.230652,602.966553 514.002197,605.581116 
	C514.693298,607.923401 513.198425,609.463562 511.367126,610.432190 
	C507.734283,612.353699 507.089996,615.419861 507.116425,619.187073 
	C507.219269,633.852051 507.238068,648.520142 507.025543,663.183289 
	C506.963226,667.483276 508.294128,669.290710 512.748901,668.934937 
	C516.724243,668.617371 520.756104,668.645996 524.739929,668.893677 
	C529.131592,669.166626 532.049011,667.310730 534.209900,663.266113 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M429.381287,772.921143 
	C427.857117,771.137878 427.682953,769.724426 429.416656,768.396179 
	C435.029236,764.096130 445.418335,766.279114 448.513245,772.481079 
	C450.331818,776.125305 453.400574,774.809387 456.137817,774.881165 
	C457.223663,772.131714 455.558350,771.089417 453.764404,770.613098 
	C450.549133,769.759583 448.872040,767.110596 447.104645,764.868469 
	C443.688965,760.535400 445.892883,754.440918 451.159271,753.213379 
	C453.031403,752.777039 454.653900,751.224976 457.423401,751.920471 
	C453.429504,758.195801 457.298889,761.304443 461.968842,764.624023 
	C465.295929,766.989075 468.753204,770.340759 466.679199,775.078186 
	C464.867126,779.217285 461.543030,781.140442 456.427155,781.308289 
	C449.465729,781.536560 443.884674,779.384583 438.708710,775.188110 
	C436.066864,773.046143 432.386475,775.261108 429.381287,772.921143 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M597.477600,741.361084 
	C605.001648,746.301514 608.004089,754.157959 605.677246,762.262085 
	C604.580688,766.081299 594.553833,771.353210 590.822144,770.097229 
	C589.178101,769.543884 588.375671,768.321228 588.366821,766.720459 
	C588.355774,764.725464 588.504761,762.628601 590.405518,761.386536 
	C592.785950,759.830994 593.749695,762.893066 595.595093,763.160461 
	C598.098755,756.795776 594.354614,750.336426 589.048096,745.754028 
	C587.284851,748.096802 587.499939,750.612488 589.179382,752.488098 
	C591.189392,754.732788 592.991760,756.803650 589.773132,758.978699 
	C586.804321,760.984863 583.606323,760.059753 581.223145,757.612793 
	C577.548645,753.839844 577.802734,751.187805 581.905212,744.907532 
	C585.693237,739.108643 591.883484,737.578430 597.477600,741.361084 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M546.719971,758.953003 
	C546.356934,765.508850 549.553955,770.775024 551.191101,776.432495 
	C551.480103,777.431274 551.701111,778.456726 552.961365,778.482483 
	C554.520996,778.514404 554.917603,777.307007 554.923218,776.110229 
	C554.930176,774.627991 555.211121,772.684753 554.419495,771.741028 
	C550.977295,767.636963 552.693359,761.986755 549.806519,757.694580 
	C548.660034,755.990051 550.018921,754.029968 552.174438,755.060242 
	C556.726074,757.235779 560.773926,759.531311 562.609863,765.328491 
	C564.473999,771.214722 566.159119,776.231628 561.941284,781.655151 
	C560.470703,783.546021 559.199341,784.827026 556.650085,784.456482 
	C555.370789,784.270569 554.003601,784.464905 552.705444,784.671631 
	C546.494385,785.660767 541.902771,782.645691 541.006897,776.445007 
	C540.294250,771.512817 540.050232,766.474609 540.911682,761.524902 
	C541.449707,758.433777 542.679016,755.793091 546.719971,758.953003 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M524.005737,769.730835 
	C519.651062,771.038940 518.509033,768.911072 518.814331,765.427917 
	C519.082336,762.370117 520.304565,760.206055 523.944824,761.318848 
	C525.270386,761.724060 526.479980,761.731079 527.829041,761.377991 
	C530.480591,760.684021 533.563782,759.097961 535.525879,762.202759 
	C537.481201,765.296692 540.093628,768.475891 537.306519,772.652588 
	C535.756409,774.975525 535.196594,777.307739 538.631165,779.175842 
	C540.757568,780.332458 541.189148,782.958618 540.471924,785.419556 
	C539.820312,787.655518 537.999756,788.567078 535.925476,788.690918 
	C531.954651,788.928101 527.969238,788.997009 523.990234,788.986511 
	C522.115662,788.981506 520.256531,788.472717 519.542053,786.433716 
	C518.728699,784.112427 520.480408,783.225769 522.095703,782.267395 
	C526.528137,779.637390 527.414062,774.884949 528.841675,770.539429 
	C529.352356,768.984985 529.052246,767.196716 527.075928,766.326599 
	C525.244812,766.589417 525.639282,768.813782 524.005737,769.730835 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M489.933594,766.365234 
	C488.188171,772.206299 486.551727,777.910583 485.365845,783.707031 
	C484.779999,786.570618 483.835144,788.355469 480.652466,788.249512 
	C477.525848,788.145325 475.581787,786.570618 475.188019,783.524170 
	C474.575806,778.787537 476.021545,774.319824 477.517365,769.918396 
	C478.209045,767.883179 479.320770,765.960754 477.898346,763.635803 
	C477.311462,763.602722 476.647125,763.436157 476.038544,763.555054 
	C474.152435,763.923706 472.299744,764.148438 471.300049,762.046570 
	C470.682861,760.748901 471.088013,759.393250 471.878784,758.267883 
	C473.137909,756.476013 475.146576,756.313354 476.815186,757.051208 
	C480.598022,758.723877 485.147003,757.917358 488.514191,760.815674 
	C489.725281,761.858154 491.020264,761.094727 492.305328,760.870789 
	C494.348083,760.514832 496.327820,760.721863 497.834747,762.337708 
	C499.296265,763.904724 499.108490,765.739258 498.154816,767.427490 
	C496.975342,769.515503 495.444672,768.553040 493.904694,767.744263 
	C492.741394,767.133362 491.458191,766.750671 489.933594,766.365234 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M427.184570,758.558411 
	C425.855499,760.845459 424.854248,762.961243 423.501587,764.821411 
	C421.005890,768.253479 417.796814,767.081177 415.153412,765.286804 
	C412.460602,763.458984 411.980042,760.374329 413.997986,757.834839 
	C417.831207,753.011047 420.266510,747.355042 423.777985,742.352539 
	C425.164948,740.376587 426.225525,737.858093 429.059937,739.913208 
	C431.675293,741.809509 435.827362,743.218689 433.260284,747.960938 
	C432.420227,749.512695 430.594238,750.562683 430.809509,752.667725 
	C436.895203,753.567261 438.343018,754.993896 437.272400,759.018616 
	C436.875336,760.511292 436.303253,761.954407 434.586853,762.267029 
	C433.016602,762.552979 432.277832,761.369507 431.489960,760.236694 
	C430.517578,758.838745 429.787415,756.687256 427.184570,758.558411 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M569.083984,763.188965 
	C562.970154,757.467285 562.827942,756.870544 566.401367,752.587341 
	C569.538147,748.827576 572.423584,748.829468 574.875793,753.144531 
	C576.981689,756.850220 578.589600,760.886841 579.985840,764.926392 
	C580.631042,766.793213 581.051636,768.676758 582.075684,770.441467 
	C583.638672,773.134888 583.362671,775.641357 580.229126,777.075623 
	C577.184143,778.469360 575.107849,777.973328 573.529602,774.456421 
	C571.914795,770.858154 569.501648,767.626892 569.083984,763.188965 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M504.856567,782.790039 
	C506.985046,784.252014 507.521027,785.926392 505.884918,787.509949 
	C503.784760,789.542969 501.154449,789.644531 498.589539,788.386108 
	C497.085022,787.648071 496.608917,786.158142 497.050903,784.605713 
	C497.785889,782.024109 499.828430,781.623657 502.137146,781.967407 
	C502.939514,782.086914 503.713409,782.397400 504.856567,782.790039 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M443.977478,754.487183 
	C441.480103,756.166992 439.726318,755.425903 439.018616,753.147522 
	C438.348633,750.990662 437.742523,748.444763 440.010651,746.729248 
	C441.934235,745.274414 443.557220,746.303467 444.478088,748.124023 
	C445.482147,750.109070 445.731842,752.246582 443.977478,754.487183 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M461.751526,754.438293 
	C464.592560,753.479980 465.814789,754.723572 466.160248,757.029663 
	C466.411957,758.710022 466.144836,760.333862 464.487640,761.298096 
	C463.486298,761.880737 462.490906,761.576904 461.907135,760.692017 
	C460.658539,758.799622 459.112000,756.844788 461.751526,754.438293 
z"/>
    </svg>
  )
}
